import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const updateAllAcountStatus = (id, params, type) => {
  return Api(
    `${endPoints.updateAllAcountStatus}/${id}?type=${type}`,
    params,
    requestType.PUT
  );
};

const getAddressDetailByPlaceId = (id) => {
  return Api(
    `${endPoints.getAddressDetailByPlaceId}/${id}`,
    null,
    requestType.GET
  );
};

const getCurrentSubscription = (id, type) => {
  return Api(
    `${endPoints.getCurrentSubscription}/${id}/${type}`,
    null,
    requestType.GET
  );
};

const getSubscriptionDetailById = (id) => {
  return Api(
    `${endPoints.getSubscriptionDetailById}/${id}`,
    null,
    requestType.GET
  );
};

export {
  updateAllAcountStatus,
  getAddressDetailByPlaceId,
  getCurrentSubscription,
  getSubscriptionDetailById,
};
